// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Reset (scoped to component) ───────────────────────────── */
.story-viewer_overlay__WBZnK *,
.story-viewer_overlay__WBZnK *::before,
.story-viewer_overlay__WBZnK *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.story-viewer_card__tpHxV {
  --progress-h: 3px;
  --close-size: 36px;
  --radius: 16px;
  --transition: 0.22s ease;
}

/* ─── Overlay ─────────────────────────────────────────── */
.story-viewer_overlay__WBZnK {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.92);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: story-viewer_fadeIn__EsElC 0.2s ease forwards;
}

@keyframes story-viewer_fadeIn__EsElC { from { opacity: 0; } to { opacity: 1; } }
@keyframes story-viewer_fadeOut__lNsIr { from { opacity: 1; } to { opacity: 0; } }
@keyframes story-viewer_progress__JTLvD { from { width: 0%; } to { width: 100%; } }

.story-viewer_overlay__WBZnK.story-viewer_closing__5TKzF { animation: story-viewer_fadeOut__lNsIr 0.2s ease forwards; }

/* ─── Card ────────────────────────────────────────────── */
.story-viewer_card__tpHxV {
  position: relative;
  width: 100%;
  height: 100dvh;
  max-width: 420px;
  background: #111;
  overflow: hidden;
  border-radius: 0;
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

@media (min-width: 600px) {
  .story-viewer_card__tpHxV {
    height: min(94dvh, 820px);
    border-radius: var(--radius);
    box-shadow: 0 32px 80px rgba(0, 0, 0, 0.9);
  }
}

/* ─── Progress ────────────────────────────────────────── */
.story-viewer_progress__JTLvD {
  position: absolute;
  top: 0; left: 0; right: 0;
  z-index: 10;
  display: flex;
  gap: 4px;
  padding: 10px 12px 6px;
}

.story-viewer_progItem__trR1s {
  flex: 1 1;
  height: var(--progress-h);
  background: rgba(255, 255, 255, 0.35);
  border-radius: 99px;
  overflow: hidden;
}

.story-viewer_progFill__1LLE8 {
  height: 100%;
  background: #fff;
  border-radius: 99px;
  width: 0%;
}

.story-viewer_done__Zy60R .story-viewer_progFill__1LLE8 {
  width: 100%;
}

/* .progItem.done .progFill {
  width: 100%;
  transition: none;
} */

/* .progItem.done .progFill {
  width: 100%;
} */

/* ─── Header ──────────────────────────────────────────── */
.story-viewer_header__fr6i0 {
  position: absolute;
  top: 0; left: 0; right: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 22px 14px 10px;
  background: linear-gradient(to bottom, rgba(0,0,0,0.65) 0%, transparent 100%);
}

.story-viewer_avatar__A5OMf {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #fff;
  flex-shrink: 0;
}

.story-viewer_avatarPlaceholder__Llt1s {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  flex-shrink: 0;
  background: linear-gradient(135deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888);
}

.story-viewer_meta__lIlFS { flex: 1 1; min-width: 0; }

.story-viewer_username__q0VqF {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.story-viewer_time__-vgum {
  color: rgba(255,255,255,0.7);
  font-size: 12px;
  margin-top: 1px;
}

/* ─── Close Button ────────────────────────────────────── */
.story-viewer_closeBtn__xttE1 {
  width: var(--close-size);
  height: var(--close-size);
  border-radius: 50%;
  background: rgba(255,255,255,0.15);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background var(--transition), transform var(--transition);
  -webkit-tap-highlight-color: transparent;
}

.story-viewer_closeBtn__xttE1:hover  { background: rgba(255,255,255,0.28); }
.story-viewer_closeBtn__xttE1:active { transform: scale(0.9); }

.story-viewer_closeBtn__xttE1 svg {
  width: 18px; height: 18px;
  stroke: #fff; fill: none;
  stroke-width: 2.2;
  stroke-linecap: round;
}

/* ─── Media ───────────────────────────────────────────── */
.story-viewer_media__VZ57u {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
}

.story-viewer_media__VZ57u img,
.story-viewer_media__VZ57u video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

.story-viewer_media__VZ57u.story-viewer_contain__leaSj img,
.story-viewer_media__VZ57u.story-viewer_contain__leaSj video {
  object-fit: contain;
}

/* ─── Loader ──────────────────────────────────────────── */
.story-viewer_loader__V1DsE {
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.4);
}

.story-viewer_spinner__zwxUx {
  width: 40px; height: 40px;
  border: 3px solid rgba(255,255,255,0.2);
  border-top-color: #fff;
  border-radius: 50%;
  animation: story-viewer_spin__mnT53 0.7s linear infinite;
}

@keyframes story-viewer_spin__mnT53 { to { transform: rotate(360deg); } }

/* ─── Tap Zones ───────────────────────────────────────── */
.story-viewer_tap__D2e69 {
  position: absolute;
  top: 0; bottom: 0;
  z-index: 8;
  width: 35%;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.story-viewer_tap__D2e69.story-viewer_prev__Gktmv { left: 0; }
.story-viewer_tap__D2e69.story-viewer_next__n0217 { right: 0; }

/* ─── Caption ─────────────────────────────────────────── */
.story-viewer_caption__KzKW3 {
  position: absolute;
  bottom: 0; left: 0; right: 0;
  z-index: 9;
  padding: 48px 16px 24px;
  background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 100%);
  color: #fff;
  font-size: 14px;
  line-height: 1.5;
}

/* ─── Mute Button ─────────────────────────────────────── */
.story-viewer_mute__fvUYz {
  position: absolute;
  bottom: 20px; right: 16px;
  z-index: 10;
  width: 34px; height: 34px;
  border-radius: 50%;
  background: rgba(255,255,255,0.18);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background var(--transition);
  -webkit-tap-highlight-color: transparent;
}

.story-viewer_mute__fvUYz:hover { background: rgba(255,255,255,0.3); }

.story-viewer_mute__fvUYz svg {
  width: 16px; height: 16px;
  stroke: #fff; fill: none;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
`, "",{"version":3,"sources":["webpack://./src/components/story-viewer/story-viewer.module.css"],"names":[],"mappings":"AAAA,kEAAkE;AAClE;;;EAGE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,wBAAwB;AAC1B;;AAEA,4DAA4D;AAC5D;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wDAAoC;AACtC;;AAEA,wCAAoB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;AAC5D,yCAAqB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;AAC7D,0CAAsB,OAAO,SAAS,EAAE,EAAE,KAAK,WAAW,EAAE,EAAE;;AAE9D,2DAAmB,yDAAqC,EAAE;;AAE1D,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE;IACE,yBAAyB;IACzB,4BAA4B;IAC5B,0CAA0C;EAC5C;AACF;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,WAAW;EACX,aAAa;EACb,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;;;GAGG;;AAEH;;GAEG;;AAEH,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,6EAA6E;AAC/E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,gFAAgF;AAClF;;AAEA,4BAAQ,SAAO,EAAE,YAAY,EAAE;;AAE/B;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,eAAe;AACjB;;AAEA,4DAA4D;AAC5D;EACE,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,qEAAqE;EACrE,wCAAwC;AAC1C;;AAEA,uCAAmB,kCAAkC,EAAE;AACvD,uCAAmB,qBAAqB,EAAE;;AAE1C;EACE,WAAW,EAAE,YAAY;EACzB,YAAY,EAAE,UAAU;EACxB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,WAAW,EAAE,YAAY;EACzB,uCAAuC;EACvC,sBAAsB;EACtB,kBAAkB;EAClB,wDAAoC;AACtC;;AAEA,sCAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,MAAM,EAAE,SAAS;EACjB,UAAU;EACV,UAAU;EACV,eAAe;EACf,wCAAwC;AAC1C;AACA,oDAAY,OAAO,EAAE;AACrB,oDAAY,QAAQ,EAAE;;AAEtB,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,SAAS,EAAE,OAAO,EAAE,QAAQ;EAC5B,UAAU;EACV,uBAAuB;EACvB,yEAAyE;EACzE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,YAAY,EAAE,WAAW;EACzB,WAAW;EACX,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA,kCAAc,iCAAiC,EAAE;;AAEjD;EACE,WAAW,EAAE,YAAY;EACzB,YAAY,EAAE,UAAU;EACxB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB","sourcesContent":["/* ─── Reset (scoped to component) ───────────────────────────── */\r\n.overlay *,\r\n.overlay *::before,\r\n.overlay *::after {\r\n  box-sizing: border-box;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.card {\r\n  --progress-h: 3px;\r\n  --close-size: 36px;\r\n  --radius: 16px;\r\n  --transition: 0.22s ease;\r\n}\r\n\r\n/* ─── Overlay ─────────────────────────────────────────── */\r\n.overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 9999;\r\n  background: rgba(0, 0, 0, 0.92);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  animation: fadeIn 0.2s ease forwards;\r\n}\r\n\r\n@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }\r\n@keyframes fadeOut { from { opacity: 1; } to { opacity: 0; } }\r\n@keyframes progress { from { width: 0%; } to { width: 100%; } }\r\n\r\n.overlay.closing { animation: fadeOut 0.2s ease forwards; }\r\n\r\n/* ─── Card ────────────────────────────────────────────── */\r\n.card {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100dvh;\r\n  max-width: 420px;\r\n  background: #111;\r\n  overflow: hidden;\r\n  border-radius: 0;\r\n  padding-bottom: env(safe-area-inset-bottom, 0px);\r\n}\r\n\r\n@media (min-width: 600px) {\r\n  .card {\r\n    height: min(94dvh, 820px);\r\n    border-radius: var(--radius);\r\n    box-shadow: 0 32px 80px rgba(0, 0, 0, 0.9);\r\n  }\r\n}\r\n\r\n/* ─── Progress ────────────────────────────────────────── */\r\n.progress {\r\n  position: absolute;\r\n  top: 0; left: 0; right: 0;\r\n  z-index: 10;\r\n  display: flex;\r\n  gap: 4px;\r\n  padding: 10px 12px 6px;\r\n}\r\n\r\n.progItem {\r\n  flex: 1;\r\n  height: var(--progress-h);\r\n  background: rgba(255, 255, 255, 0.35);\r\n  border-radius: 99px;\r\n  overflow: hidden;\r\n}\r\n\r\n.progFill {\r\n  height: 100%;\r\n  background: #fff;\r\n  border-radius: 99px;\r\n  width: 0%;\r\n}\r\n\r\n.done .progFill {\r\n  width: 100%;\r\n}\r\n\r\n/* .progItem.done .progFill {\r\n  width: 100%;\r\n  transition: none;\r\n} */\r\n\r\n/* .progItem.done .progFill {\r\n  width: 100%;\r\n} */\r\n\r\n/* ─── Header ──────────────────────────────────────────── */\r\n.header {\r\n  position: absolute;\r\n  top: 0; left: 0; right: 0;\r\n  z-index: 10;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 22px 14px 10px;\r\n  background: linear-gradient(to bottom, rgba(0,0,0,0.65) 0%, transparent 100%);\r\n}\r\n\r\n.avatar {\r\n  width: 38px;\r\n  height: 38px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n  border: 2px solid #fff;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.avatarPlaceholder {\r\n  width: 38px;\r\n  height: 38px;\r\n  border-radius: 50%;\r\n  flex-shrink: 0;\r\n  background: linear-gradient(135deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888);\r\n}\r\n\r\n.meta { flex: 1; min-width: 0; }\r\n\r\n.username {\r\n  color: #fff;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.time {\r\n  color: rgba(255,255,255,0.7);\r\n  font-size: 12px;\r\n  margin-top: 1px;\r\n}\r\n\r\n/* ─── Close Button ────────────────────────────────────── */\r\n.closeBtn {\r\n  width: var(--close-size);\r\n  height: var(--close-size);\r\n  border-radius: 50%;\r\n  background: rgba(255,255,255,0.15);\r\n  backdrop-filter: blur(8px);\r\n  -webkit-backdrop-filter: blur(8px);\r\n  border: none;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  transition: background var(--transition), transform var(--transition);\r\n  -webkit-tap-highlight-color: transparent;\r\n}\r\n\r\n.closeBtn:hover  { background: rgba(255,255,255,0.28); }\r\n.closeBtn:active { transform: scale(0.9); }\r\n\r\n.closeBtn svg {\r\n  width: 18px; height: 18px;\r\n  stroke: #fff; fill: none;\r\n  stroke-width: 2.2;\r\n  stroke-linecap: round;\r\n}\r\n\r\n/* ─── Media ───────────────────────────────────────────── */\r\n.media {\r\n  position: absolute;\r\n  inset: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: #000;\r\n}\r\n\r\n.media img,\r\n.media video {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  object-position: center;\r\n  display: block;\r\n}\r\n\r\n.media.contain img,\r\n.media.contain video {\r\n  object-fit: contain;\r\n}\r\n\r\n/* ─── Loader ──────────────────────────────────────────── */\r\n.loader {\r\n  position: absolute;\r\n  inset: 0;\r\n  z-index: 5;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: rgba(0,0,0,0.4);\r\n}\r\n\r\n.spinner {\r\n  width: 40px; height: 40px;\r\n  border: 3px solid rgba(255,255,255,0.2);\r\n  border-top-color: #fff;\r\n  border-radius: 50%;\r\n  animation: spin 0.7s linear infinite;\r\n}\r\n\r\n@keyframes spin { to { transform: rotate(360deg); } }\r\n\r\n/* ─── Tap Zones ───────────────────────────────────────── */\r\n.tap {\r\n  position: absolute;\r\n  top: 0; bottom: 0;\r\n  z-index: 8;\r\n  width: 35%;\r\n  cursor: pointer;\r\n  -webkit-tap-highlight-color: transparent;\r\n}\r\n.tap.prev { left: 0; }\r\n.tap.next { right: 0; }\r\n\r\n/* ─── Caption ─────────────────────────────────────────── */\r\n.caption {\r\n  position: absolute;\r\n  bottom: 0; left: 0; right: 0;\r\n  z-index: 9;\r\n  padding: 48px 16px 24px;\r\n  background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 100%);\r\n  color: #fff;\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n}\r\n\r\n/* ─── Mute Button ─────────────────────────────────────── */\r\n.mute {\r\n  position: absolute;\r\n  bottom: 20px; right: 16px;\r\n  z-index: 10;\r\n  width: 34px; height: 34px;\r\n  border-radius: 50%;\r\n  background: rgba(255,255,255,0.18);\r\n  backdrop-filter: blur(6px);\r\n  -webkit-backdrop-filter: blur(6px);\r\n  border: none;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background var(--transition);\r\n  -webkit-tap-highlight-color: transparent;\r\n}\r\n\r\n.mute:hover { background: rgba(255,255,255,0.3); }\r\n\r\n.mute svg {\r\n  width: 16px; height: 16px;\r\n  stroke: #fff; fill: none;\r\n  stroke-width: 2;\r\n  stroke-linecap: round;\r\n  stroke-linejoin: round;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `story-viewer_overlay__WBZnK`,
	"card": `story-viewer_card__tpHxV`,
	"fadeIn": `story-viewer_fadeIn__EsElC`,
	"closing": `story-viewer_closing__5TKzF`,
	"fadeOut": `story-viewer_fadeOut__lNsIr`,
	"progress": `story-viewer_progress__JTLvD`,
	"progItem": `story-viewer_progItem__trR1s`,
	"progFill": `story-viewer_progFill__1LLE8`,
	"done": `story-viewer_done__Zy60R`,
	"header": `story-viewer_header__fr6i0`,
	"avatar": `story-viewer_avatar__A5OMf`,
	"avatarPlaceholder": `story-viewer_avatarPlaceholder__Llt1s`,
	"meta": `story-viewer_meta__lIlFS`,
	"username": `story-viewer_username__q0VqF`,
	"time": `story-viewer_time__-vgum`,
	"closeBtn": `story-viewer_closeBtn__xttE1`,
	"media": `story-viewer_media__VZ57u`,
	"contain": `story-viewer_contain__leaSj`,
	"loader": `story-viewer_loader__V1DsE`,
	"spinner": `story-viewer_spinner__zwxUx`,
	"spin": `story-viewer_spin__mnT53`,
	"tap": `story-viewer_tap__D2e69`,
	"prev": `story-viewer_prev__Gktmv`,
	"next": `story-viewer_next__n0217`,
	"caption": `story-viewer_caption__KzKW3`,
	"mute": `story-viewer_mute__fvUYz`
};
export default ___CSS_LOADER_EXPORT___;
